<script lang="ts">
    import { computed } from 'vue';

    const component = {
        name: 'ModalContainer',
    };
    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const props = withDefaults(
        defineProps<{
            show: boolean;
            x: number;
            y: number;
            h: number;
            w: number;
            containerRect: DOMRect;
            container: {
                h: number;
                w: number;
            };
            title: string;
            margin?: number;
        }>(),
        {
            margin: 15,
        }
    );

    const contained = computed(() => {
        let { x, y, h, w, container, margin } = props;
        return {
            x: x + w < container.w ? x : x - (x + w - container.w) - margin,
            y: y + h < container.h ? y : y - (y + h - container.h) - margin,
        };
    });
</script>

<template>
    <transition name="toggle">
        <div
            class="modal_container"
            v-if="show"
            :style="{
                transform: `translate3d(${contained.x}px, ${contained.y}px, 0)`,
                height: `${h}px`,
                width: `${w}px`,
            }">
            <div class="title-bar align-fl-c">
                <h3 class="small fw400" style="margin: 0">{{ title }}</h3>
            </div>
            <div class="modal_body">
                <slot />
            </div>
            <div class="modal-bottom"></div>
        </div>
    </transition>
</template>

<style>
    .modal_container {
        display: flex;
        position: absolute;
        flex-direction: column;
        background-color: white;
        overflow: hidden;
        z-index: 10;
        background-color: #fff; /* fallback */
        border-radius: 0.4rem;
        box-shadow: 0.2rem 0.7rem 1.4rem -0.6rem #00000033;
        transform-origin: top;
        transition-property: transform;
        transition-duration: var(--td-four);
        transition-timing-function: var(--ttf-eager);
    }

    .title-bar {
        flex-shrink: 0;
        height: 1.5rem;
        background-color: #35323b;
    }

    .title-bar h3 {
        color: #fff;
    }

    .modal_body {
        position: relative;
        height: 100%;
        padding: 0.25rem 0.75rem 1.5rem 0.75rem;
        overflow: auto;
    }

    .modal-bottom {
        flex-shrink: 0;
        height: 0.7rem;
        border-top: 1px solid #ddddddc2;
        background-color: hsl(0, 0%, 98%);
    }

    .modal-bottom:empty {
        display: none;
    }

    .toggle-enter-active,
    .toggle-leave-active {
        transition-property: opacity, height;
        transition-duration: 0.06s, 0.1s;
        transition-timing-function: ease-out;
    }

    .toggle-leave-active {
        transition-duration: 0.1s, 0.15s;
        transition-delay: 0.06s, 0s;
    }

    .toggle-enter-from,
    .toggle-leave-to {
        height: 1.6rem !important;
        opacity: 0;
    }
</style>
